import { render } from "./HighKneesGame.vue?vue&type=template&id=648607a3&scoped=true"
import script from "./HighKneesGame.vue?vue&type=script&lang=js"
export * from "./HighKneesGame.vue?vue&type=script&lang=js"

import "./HighKneesGame.vue?vue&type=style&index=0&id=648607a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648607a3"]])

export default __exports__